import { render, staticRenderFns } from "./InputParametersHomeworkRegister.vue?vue&type=template&id=884c3ed4&scoped=true"
import script from "./InputParametersHomeworkRegister.vue?vue&type=script&lang=js"
export * from "./InputParametersHomeworkRegister.vue?vue&type=script&lang=js"
import style0 from "./InputParametersHomeworkRegister.vue?vue&type=style&index=0&id=884c3ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884c3ed4",
  null
  
)

export default component.exports